import { useEffect, useState } from 'react';
import axios from "axios";
const { config } = require('@homewise-solutions-inc/pkg-react-utils');
import parse from 'parse-link-header';

const getSchemaLinks = async () => {
  return await axios({
    method: "GET",
    url: `${config.api.BASE}/product/meta?group=homewise`,
  });
};

const getSchema = async (link) => {
  return await axios({
    method: "GET",
    url: link,
  });
};

/**
 * Simplified, re-usable hook for loading the schema.
 * @returns {Object} Schema
 */
export const useSchema = (schemaName) => {
  const [schema, setSchema] = useState({});

  useEffect(() => {
    async function getSchema() {
      const loadSchemaLinks = await getSchemaLinks(), isSchemaEmpty = !Object.keys(schema).length;
      
      let header = loadSchemaLinks.headers.link, parsed = parse(header), links = {};
      
      const urlsObject = Object.entries(parsed);
      
      urlsObject.forEach(([key, value]) => {
        links[value.rel] = value.url;
      });

      if (links && isSchemaEmpty) {
        // const res = await getSchema(links[schemaName]);
        // if (res.status === 200) setSchema(res.data);
        // else console.log('Failed to load schema' ,res.status);
        fetch(links[schemaName])
          .then((response) => response.json())
          .then((data) => {
            setSchema(data);
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              return console.log('Request was aborted');
            }
            console.log('Request canceled', error);
          });
      }
    }

    getSchema();
  }, []);

  return schema;
};